import { medicalPatient, retailOffice, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: "RFID là từ viết tắt của 'Radio-Frequency Identification', có nghĩa là công nghệ nhận dạng tần số vô tuyến, được sử dụng để nhận diện và quản lý các vật thể một cách độc nhất bằng cách truyền và nhận dữ liệu thông qua giao tiếp không dây.",
  keywords: 'RFID, RTLS, truyền thông không dây, theo dõi vị trí, rfid, rtls, truyenthong khong day, theodoi vitri.',
  ogSite: 'RFID là gì?',
  title: 'RFID là gì?',
  ogUrl: 'https://orbro.io/vi/blog/rfid',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDnHsX6sdpDkHidg6Qw1BNPI-8KHNunrbQX70t-RRiZFc_m0TXoYRKa1E9Qo01-Au848tK9S5Jzx1vOsreK1FoM7_WUn-aUPsNq2SoW1p0bgotbqEic-B-shh4JqyX1vRGz1BKJuuNybUGEV0Sntx7H_5LpXctuKvQDlllya8Qrt86WPh2Z8-5f8fKO1zJH2O8i96n9h1SvE8MHibKQqZzHRsPx4JboT3-j7Dq6nMb3Gsk-bMZkqaQVCKMuKmSG9s28DFXjSr2dDlwKXTgw6HPGwcGijF3sdo52c8MtyGSFhBtgtmGbjidDLlTEoYy5sTjCUl9KoRk5SbaOqCb-WHfrMzvlUE-KzSkFspk4Qe_oDLl4U2mcOBOC6tpykKzDDNY3P-si0yNBW_3kHTZd8ITgkwKE1AwK0hHOdS0FB7_AvrfgQW1VAIpkjYlJFHXsbP3Nac0v-XjWu9W-fozT8vIJC3P5c5imd_plMzSJorI4po9xbiqNGReeiJpbzilK2ym2B2i8MZT6w2SRjdf2nm2SU4Ru4aZR60ahb8bagWe_xc_ZzKNmdlZu5Avvkyc3_fUGnnqw3d3xcwaPdtRhYQul_0LDKxsgKrBjv2Co6CztB1mX2Et8-F5j68r2F9qy1yj6abH08yQokpafvTmxUsBYZ_i4OAw30nPlQkXflKfWFTob2y_o-X_FvVTGl4qerYTVBQLafVq7aSdlwkNpTvzZbXYkJMJasDN8JRO6mBJ8WhoJm9GOF5z75doXv-ds7jiNur5KLdA_UC2SR6-GpDrQPew6gUqn_1NvNGCXxkH9skkPX6gIuzc-9EAaXkSNajXWEc9_cRppxNODr4m1x_rl00fnHmVra7BhMXTjEgsB7rUJJw9OdKbTvB565TUXJXGMIfiFUAJfYBgm3FRZfJobff73T4LEa7d6e-znqcf64EINs_qnz2n-6yqf6_8Ww7A3P2K_iKCJymzKYy-dmjnxIW7c_msNP3sQZ0Ev0CpMW2neef16CpS2qPJjSc1Hv977oz4JSkrCL2GJ3RIUILnczDL8Ww96raGuIs058uNZu-pJwbIEbr9995dIPiHY-a6wstUW8xKthzZmdCFJ2JInX_Mos6jxXNorixlMOiseVcCXzuEcH_QEXGn9Mj7GzKkhAwgYeEq3D7EMlwjQ56-8mACmRW1ein59VVTW8JoXlBZ0enRBVmONwC4Y0aUUc_Hn70Zbktx4y1pKsehMCWy3GnGikZej6coDNKuKPnv8VE2ZBfCy8QdoI0i4P9rH2zFPqJWJEEgYmy3MpmnS5Asf8f1aScgjVS1S06wmBN_9Lpa-3cUJ-epljLU28BaHQWk9f2z4XojkWBWXVnGCidPhbxH-Cx4l-mNjXL8bh9PixgnFknFkWbwaqqGfjgS-GvOPqF0uGlIlEavfeovi1d_1opq7fxuM6wc-y17eImZEycGDKQuMRds6xvylNau1IgJTWCxWfnHArzBoJMxU91IlULuYkMFPAmoA-U2JjLAeiz35GX1eHmMQ3k_2JZmlfIvGQ73K2zf9ErNr-QzQPqixYph1iRaJi=w1984-h1214',
  ogType: 'website',
  date: '2024-01-11',
  tag1: '#RFID',
  tag2: '#RTLS',
  tag3: '#Truyenthongkhongday',
  tag4: '#Theodoivitri',
  text: [
    {
      head: 'RFID là gì?',
      subHead: '',
      desc: "RFID là từ viết tắt của 'Radio-Frequency Identification', có nghĩa là công nghệ nhận dạng tần số vô tuyến, được sử dụng để nhận diện và quản lý các vật thể một cách độc nhất bằng cách truyền và nhận dữ liệu thông qua giao tiếp không dây.\nHệ thống RFID chủ yếu bao gồm Thẻ (Tag), Đầu đọc (Reader hay Interrogator) và cơ sở dữ liệu (Database). Thẻ là thành phần chính của hệ thống RFID, bao gồm một chip nhỏ và một ăng-ten. Chip này được gắn hoặc tích hợp vào vật thể, còn ăng-ten chịu trách nhiệm truyền và nhận tín hiệu vô tuyến. Đầu đọc giao tiếp với thẻ thông qua ăng-ten, đọc hoặc ghi dữ liệu, và kết nối thông tin này với cơ sở dữ liệu để theo dõi hoặc quản lý thông tin theo thời gian thực.",
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng RFID',
      subHead: '',
      desc: 'Công nghệ RFID đang được ứng dụng đa dạng trong nhiều lĩnh vực công nghiệp khác nhau. Một số ví dụ điển hình về ứng dụng của RFID như sau',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Phân phối và Logistics',
      desc: 'Quản lý Tồn kho: Sử dụng RFID để gắn thẻ lên sản phẩm và theo dõi tồn kho theo thời gian thực thông qua đầu đọc, cung cấp thông tin tồn kho chính xác.\nXử lý Logistics tự động: Tự động hóa quá trình vận chuyển và phân loại sản phẩm tại các trung tâm logistics, nâng cao hiệu quả hoạt động logistics.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành Sản xuất',
      desc: 'Theo dõi Sản phẩm và Quản lý Sản xuất: Các nhà sản xuất gắn thẻ RFID vào sản phẩm để theo dõi dây chuyền sản xuất và thực hiện giám sát theo thời gian thực trong các giai đoạn sản xuất và giao hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành Bán lẻ',
      desc: 'Cửa hàng Thông minh: Sử dụng công nghệ RFID để triển khai các cửa hàng thông minh, nơi khách hàng có thể tự động lập hóa đơn và thanh toán khi lấy sản phẩm.\nNâng cao Trải nghiệm Khách hàng: Sử dụng RFID để giúp khách hàng dễ dàng tìm thấy sản phẩm hoặc tự động áp dụng các chương trình giảm giá và khuyến mãi, từ đó nâng cao trải nghiệm khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Y tế và Bệnh viện',
      desc: 'Nhận diện Bệnh nhân và Quản lý Thiết bị Y tế: Sử dụng RFID để nhận diện bệnh nhân chính xác và giám sát vị trí, trạng thái của thiết bị y tế, giúp nâng cao hiệu quả hoạt động của các cơ sở y tế.\nTheo dõi Dược phẩm: Tăng cường khả năng truy xuất nguồn gốc của dược phẩm từ khâu sản xuất đến khi đến tay bệnh nhân, đảm bảo an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hệ thống Phương tiện và Giao thông',
      desc: 'Thu phí tự động: Sử dụng RFID để tự động thu phí cầu đường và theo dõi phương tiện nhằm giảm ùn tắc giao thông.\nQuản lý và Bảo trì Phương tiện: Gắn thẻ RFID vào phương tiện để theo dõi lịch sử bảo trì và giám sát vị trí phương tiện, hỗ trợ vận hành hiệu quả.',
      dot: '',
    },
    {
      head: 'Ưu điểm của RFID',
      subHead: 'Tự động hóa và Theo dõi theo thời gian thực',
      desc: 'RFID có thể nhanh chóng nhận diện vật thể không dây và thu thập dữ liệu, hoạt động với tốc độ nhanh hơn so với các quy trình thủ công. Ngoài ra, nó có thể theo dõi vị trí và trạng thái của vật thể theo thời gian thực, giúp quản lý logistics, sản xuất và tồn kho hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thu thập Dữ liệu Chính xác',
      desc: 'So với quét mã vạch, RFID cho phép thu thập dữ liệu nhanh hơn và chính xác hơn, giảm lỗi nhập liệu. RFID có thể tự động nhận diện vật thể ngay cả trong các tình huống không có khả năng nhìn thấy trực tiếp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao Khả năng hiển thị và Tầm nhìn',
      desc: 'Sử dụng RFID giúp theo dõi minh bạch sự di chuyển của vật thể trong toàn bộ chuỗi cung ứng, từ đó nâng cao tầm nhìn. Có thể sử dụng RFID để giám sát trạng thái hoạt động theo thời gian thực trên dây chuyền sản xuất hoặc trong kho hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường Bảo mật',
      desc: 'RFID có thể phát hiện di chuyển trái phép của vật thể và được áp dụng tại các khu vực cần bảo mật để ngăn chặn truy cập trái phép. RFID cũng cho phép gán quyền truy cập riêng biệt cho từng thẻ, chỉ cho phép người dùng hoặc nhóm cụ thể truy cập.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: retailOffice.thumb,
        data: 'retailOffice',
        link: '/vi/enterprise/retail/office',
      },
    ],
  },
};
